import React from 'react';
import {
  withRouter
} from 'react-router-dom';
import {Activity} from '../ndbk-constants';
import NdbkAPI from '../ndbk-api';

class RouteRecorder extends React.Component {
    componentWillMount() {
        NdbkAPI.admin.record(Activity.PAGE_VISIT, this.props.history.location.pathname)
        this.unlisten = this.props.history.listen((location, action) => {
            NdbkAPI.admin.record(Activity.PAGE_VISIT, location.pathname)
        });

        window.addEventListener('beforeunload', (event) => {
            NdbkAPI.admin.record(Activity.WEBSITE_LEAVE, null)
        });
    }
    componentWillUnmount() {
        this.unlisten();
    }

    render() {
        return (this.props.children)
    }
}

export default withRouter(RouteRecorder);


// WEBPACK FOOTER //
// ./src/components/RouteRecorder.js